import { EMPTY_SEARCH_RESULT_MESSAGE } from '../constants';

export function SearchEmptyResults() {
  return (
    <div className="flex min-h-[320px] items-center justify-center">
      <p className="text-center text-Gray-550 typo-body4">
        {EMPTY_SEARCH_RESULT_MESSAGE}
      </p>
    </div>
  );
}
